<!--
 * @Author: guoyu
 * @Date: 2021-05-26 17:28:15
 * @LastEditors: your name
 * @LastEditTime: 2021-05-28 18:14:44
 * @Description: file content
-->
<template>
  <NPopup :show="rebate > 0" @close="close">
    <div class="rebate-content">
      <div class="congratulate">恭喜你獲得</div>
      <div class="rebate-val">+{{ rebate }}<span class="unit">幣</span></div>
      <div class="rebate-name">防疫金</div>
      <div class="rebate-button" @click="close">領取</div>
      <div class="close-dialog" @click="close"></div>
    </div>
  </NPopup>
</template>
<script>
import NPopup from '@/components/common/popup';
export default {
  components: {
    NPopup
  },
  props: {
    rebate: {
      type: [String, Number],
      default: 0
    }
  },
  methods: {
    close() {
      this.$store.dispatch('app/getUserAccount')
      this.$message.success('領取成功')
      this.$emit('close')
      this.$nextTick(()=>{
        this.$emit('destroy');
      })
    }
  },
  mounted() {
    if(this.rebate < 0) {
      this.$nextTick(()=>{
        this.$emit('destroy')
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.rebate-content {
  position: relative;
  width: 250px;
  height: 275px;
  padding: 26px 0 0;
  background: url(./images/rebate-bg.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.congratulate {
  margin: 0 0 24px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ea722f;
}
.rebate-val {
  font-weight: 500;
  font-size: 38px;
  line-height: 1;
  color: #936435;
}
.rebate-name {
  margin-top: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  color: #936435;
}
.rebate-button {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 137px;
  height: 52px;
  padding: 14px 0 0;
  font-size: 18px;
  line-height: 20px;
  background: url(./images/rebate-button.png) no-repeat;
  background-size: 100% 100%;
  color: #A15914;
  cursor: pointer;
}
.close-dialog {
  position: absolute;
  bottom: -79px;
  left: 50%;
  transform: translateX(-50%);
  width: 25px;
  height: 25px;
  background: url(./images/close.png) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.unit {
  font-size: 14px;
}
</style>
